import { render, staticRenderFns } from "./cgq_trans.vue?vue&type=template&id=730f6dbd"
import script from "./cgq_trans.vue?vue&type=script&lang=js"
export * from "./cgq_trans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports